module.exports = __webpack_public_path__ + "static/media/icon-email.cc4cc827.svg";